import React, { FC } from 'react';
import './styles.css';
import AllCollegeAdmissionBG from 'src/assets/img/all-college-adminsion-bg.jpg';
import EnquiryFormTalkToExpert from 'src/components/EnquiryFormTalkToExpert';

const Talk: FC = () => {
    
    return (
        <section className="all-colleges-admission container-fluid spac_01" style={{ background: `#3e6eb0 url(${AllCollegeAdmissionBG})`, backgroundSize: "cover" }}  data-aos="fade-up">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 " data-aos="fade-up"> 
                        <h2>Still Confused? We Will Help You</h2>
                        <p>Are you looking for admissions to pursue higher education at a top college, but need guidance? Reach out to our Admission Experts Now!</p>
                    </div> 
                    <div className="col-lg-6 col-md-6 contact-form" data-aos="fade-up"> 
                    <h2>Talk to Our Expert</h2>
                    
                        <EnquiryFormTalkToExpert type={'admissions'}/>

                      {/*}  <form action="forms/contact.php" method="post" role="form" className="php-email-form">
                            <div className="form-group">
                                <input type="text" name="name" className="form-control" id="name" placeholder="Enter Name"  />
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" name="email" id="email" placeholder="Enter Email"  />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" name="phonenumber" id="phonenumber" placeholder="Phone Number"  />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" name="collegename" id="collegename" placeholder="College Name"  />
                            </div>                     
                            <div className="text-right"><button type="submit">Talk to our Expert</button></div>
                        </form>
    */}
                    </div> 
                </div>
            </div>
        </section>
    );
};

export default Talk;